export const sidebarWidthAnimation = {
    minimized: {
        width: 88,
    },
    expanded: {
        width: 330,
    },
};

export const groupAnimation = {
    closed: {
        height: 0,
    },
    open: {
        height: 'auto',
    },
};

export const itemAnimation = {
    closed: {
        opacity: 0,
    },
    open: {
        opacity: 1,
    },
};

export const collapseTransition = { staggerChildren: 0.07, duration: 0.2, ease: 'easeInOut' };
